import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const begambleawareImg = '/images/begambleaware.png';
const gamblingCommissionImg = '/images/gambling_commission_logo.png';
const gamcareImg = '/images/gamcare.png';
const gamstopImg = '/images/gamstop_logo.png';
const ageRestrictionImg = '/images/18+.png';

const Footer = () => {
  return (
    <footer className="bg-dark-black border-t border-gray-800 mt-20" itemScope itemType="https://schema.org/Organization">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <Link to="/" data-discover="true" className="inline-block mb-4">
              <img src="/images/favicon.webp" alt="Empire Wager" className="h-10 w-auto" itemProp="logo" />
            </Link>
            <p className="text-gray-400 text-sm" itemProp="description">
              Your trusted guide to the best UK online casinos. We bring you exclusive offers and expert insights.
            </p>
            <p itemProp="name" className="hidden">Empire Wager</p>
            <p itemProp="email">
              <a href="mailto:info@empire-wagers.com" itemProp="email" className="text-gray-400 hover:text-toxic-orange transition-colors">info@empire-wagers.com</a>
            </p>
            <p itemProp="telephone">
              <a href="tel:+445511778569" itemProp="telephone" className="text-gray-400 hover:text-toxic-orange transition-colors">+44 5511 778 569</a>
            </p>
            <p itemScope itemType="https://schema.org/PostalAddress">
              <span itemProp="addressLocality">London</span>, <span itemProp="addressCountry">United Kingdom</span>
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/guides" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Guides
                </Link>
              </li>
              <li>
                <Link to="/news" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  News
                </Link>
              </li>
              <li>
                <Link to="/reviews" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>




          <div>
            <h3 className="text-white font-bold mb-4">Legal links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/responsible-gaming" data-discover="true" className="text-gray-400 hover:text-accent-red transition-colors">
                  Responsible Gaming
                </Link>
              </li>
            </ul>
          </div>



          <div>
            <h3 className="text-white font-bold mb-4">Responsible Gaming</h3>
            <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mb-8">
              <div className="flex items-center">
                <a
                    href="https://www.begambleaware.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="BeGambleAware - Responsible Gambling"
                      src={begambleawareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamblingcommission.gov.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="UK Gambling Commission"
                      src={gamblingCommissionImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamcare.org.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="GamCare - Gambling Support"
                      src={gamcareImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <a
                    href="https://www.gamstop.co.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                  <img
                      className="h-[60px] w-auto object-contain"
                      alt="Gamstop - Self-Exclusion"
                      src={gamstopImg}
                  />
                </a>
              </div>

              <div className="flex items-center">
                <img
                    className="h-[60px] w-auto object-contain"
                    alt="18+ Age Restriction"
                    src={ageRestrictionImg}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <p className="text-gray-500 text-xs leading-relaxed">
            Empire Wager operates as an independent review and comparison platform. Certain links featured on our site are affiliate partnerships, which means we may earn a commission when you click through or register through these links. This commercial relationship does not influence our editorial content, reviews, or ratings in any way. All content remains unbiased and based on our independent analysis. This website is intended for users aged 18 and over only. Please gamble responsibly. For support with problem gambling, visit BeGambleAware.org. All offers are subject to terms and conditions.
          </p>
          <p className="text-gray-600 text-xs mt-4">
            © 2025 Empire Wager. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

